module.exports = __webpack_public_path__ + "img/uk_flag.2f29a6b0.svg";